/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { RoutesActivationModel } from '@models/.';
import { ROUTES_ACTIVATION as CORE_ROUTES_ACTIVATION } from '@core/config/routes-activation';

export const ROUTES_ACTIVATION: RoutesActivationModel = {
  ...CORE_ROUTES_ACTIVATION
};
